import React, { useState } from "react";
import { Upload, Button, message, Progress, App } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { SCORM_GENERATE_PRESIGNED_URL } from "../apis/apis";

const ScormUploader = ({ set_fileKey, onUploadComplete, onUploadStart }) => {
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [video_uploading_message, set_video_uploading_message] = useState("")
    const { modal } = App.useApp();



    const handleUpload = async ({ file, onSuccess, onError }) => {
        try {
            setUploading(true);
            if (onUploadStart) onUploadStart(); // ✅ Parent ko batao - upload shuru hua
            setProgress(0);

            const FORM_DATA = new FormData();
            FORM_DATA.append("scrom_file", file.name);
            const response = await SCORM_GENERATE_PRESIGNED_URL(FORM_DATA);

            if (response?.data?.status) {
                await axios.put(response?.data?.uploadUrl, file, {
                    headers: { "Content-Type": "application/zip" },
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        if (percent >= 100) set_video_uploading_message("Uploading and Verifying...");
                        setProgress(percent >= 100 ? 99 : percent);
                    },
                });

                set_fileKey(response?.data?.fileKey);
                setProgress(100);
                onSuccess("ok");

                modal.success({
                    title: "Upload Successful",
                    content: <span>SCORM package uploaded and verified successfully.</span>,
                    centered: true,
                    onOk: () => {
                        if (onUploadComplete) onUploadComplete(); // ✅ Modal OK ke baad loading band
                    },
                    onCancel: () => {
                        if (onUploadComplete) onUploadComplete(); // ✅ Modal cross se band karne par bhi
                    },
                });
            }
        } catch (err) {
            console.error(err);
            message.error("Upload failed!");
            onError(err);
            if (onUploadComplete) onUploadComplete(); // ✅ Error pe turant band
        } finally {
            setUploading(false);
            set_video_uploading_message("");
            // ❌ onUploadComplete yahan mat rakho - success case mein modal ke baad chahiye
        }
    };


    return (
        <div>
            <Upload
                accept=".zip"
                maxCount={1}
                customRequest={handleUpload}
                showUploadList={{ showRemoveIcon: false }}
            >
                <Button icon={<UploadOutlined />} loading={uploading}>
                    Upload SCORM Package
                </Button>
            </Upload>

            {uploading && <Progress percent={progress} size="small" />}
            {progress === 99 && <>  <p style={{ color: "orange", position: "relative", top: "-5px" }}>{video_uploading_message}</p></>}
            {/* {progress === 100 && <>  <p style={{color: "#000", position:"relative", top:"-5px"}}>Upload successful & verified</p></>} */}
        </div>
    );
};

export default ScormUploader;
